import {
    findIcons,
    handleFilterButtonClick, uncheckCategoriesOnCheckedClick
} from './archive-filter';
import {datepickerMinDate} from "./datepicker";
import {ninjaforms} from "./ninjaforms";

jQuery(document).ready(function ($) {
    findIcons();
    handleFilterButtonClick();
    uncheckCategoriesOnCheckedClick();
    datepickerMinDate();
    ninjaforms($);
});
